import React from 'react'
import { Activity, Feedback, Program } from '@citruscamps/citrus-client'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/pro-duotone-svg-icons'
import { Icon } from '../Icon/Icon'
import { ActivityRow } from './ActivityRow'
import { NavLink } from 'react-router-dom'
import { ROUTES } from '../../constants/routes'

interface IProps {
  activities: Activity[]
  program: Pick<Program, 'id' | 'name'>
  loading: boolean
  relative?: boolean
  isAccessLimited?: boolean
}

export const ActivityList = ({
  program,
  activities,
  loading,
  relative,
  isAccessLimited,
}: IProps) => (
  <div className="list-group list-group-flush list-group-activity">
    {activities.length > 0 ? (
      <>
        {activities.map((activity) => (
          <div className="list-group-item" key={activity.id}>
            <div className="d-flex mb-4">
              <div className="me-5">
                <Icon
                  className="rounded inline-block border"
                  width={50}
                  height={50}
                  src={
                    activity.user
                      ? activity.user?.picture_url
                      : activity.type === 'feedback.updated'
                      ? (activity.data as Feedback).contact.picture_url
                      : '/imgs/placeholder-citrus.svg'
                  }
                  alt={
                    activity.user
                      ? activity.user.first_name
                      : activity.type === 'feedback.updated'
                      ? (activity.data as Feedback).contact.first_name
                      : 'Citrus'
                  }
                />
              </div>
              <div className="col">
                <ActivityRow activity={activity} program={program} relative={relative} />
              </div>
            </div>
          </div>
        ))}
        {isAccessLimited && (
          <div className="list-group-item">
            <div className="position-relative">
              <div className="d-flex mb-4">
                <div className="me-5">
                  <Icon
                    className="rounded inline-block"
                    width={50}
                    height={50}
                    alt="Upgrade to view more"
                    placeholder="/imgs/placeholder-user.jpg"
                  />
                </div>
                <div className="col">
                  <div className="bg-body-secondary mb-2 rounded" style={{ height: 24 }} />
                  <div className="bg-body-secondary w-25 rounded" style={{ height: 19 }} />
                </div>
              </div>
              <div className="text-center">
                <NavLink to={ROUTES.BILLING_SETTINGS}>Update my plan</NavLink>
                <div className="small w-md-75 mx-auto">
                  In order to view past history, we require you to upgrade to a Standard plan.
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    ) : loading ? (
      Array.from({ length: 3 })
        .fill(null)
        .map((_, i) => `loading-row-${i}`)
        .map((key) => (
          <div className="list-group-item" key={key}>
            <div className="d-flex mb-4">
              <div className="me-5">
                <div>
                  <div className="row-img-square animate"></div>
                </div>
              </div>
              <div className="col" style={{ height: '80px' }}>
                <div className="animate mx-3 rounded" style={{ height: '55px' }} />
              </div>
            </div>
          </div>
        ))
    ) : (
      <div className="text-body-secondary py-md-5 text-center">
        <p className="mt-5">
          <FontAwesomeIcon icon={faExclamationTriangle} size="2x" />
        </p>
        <p className="mb-xl-5">There was no activities found at this time.</p>
      </div>
    )}
  </div>
)
